import { Grid, Paper } from "@mui/material";
import { action, API, controller } from "api";
import { Button, Input, InputDate, InputTime, Select } from "controls";
import { Model, ToFormData, UseForm } from "hooks";
import { Form } from "layout";
import moment from "moment";
import { useEffect, useState } from "react";

const AddEditFollowUp = (props) => {
  const { setAlert, setShowForm, updData, inqData, setFollowUps } = props;
  const { FollowUpMdl } = Model();
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
    handleInpDate,
  } = UseForm(FollowUpMdl);

  useEffect(() => {
    updData &&
      setValues((x) => ({
        ...x,
        ...updData,
        followUpTime: moment(updData.followUpTime, "HH:mm:ss"),
      }));
    return () => {
      resetFormControls();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updData]);

  useEffect(() => {
    API(controller.FollowUpType + action.GetAllByOrg).get((res) => {
      res &&
        res?.status === 200 &&
        setTypes([...res.result.map((j) => ({ id: j.id, label: j.name }))]);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateForm = () => {
    let temp = {};
    temp.followUpDate = values.followUpDate !== "" ? "" : "Follow up date";
    temp.followUpTime = values.followUpTime !== "" ? "" : "Follow up time";
    temp.followUpTypeId = values.followUpTypeId !== "" ? "" : "Follow up type";

    setErrors({ ...temp });
    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm() && inqData) {
      setLoading(true);
      const onComplete = (res) => {
        setLoading(false);
        if (res && (res.status === 201 || res.status === 200)) {
          if (setFollowUps && res.result.id) {
            updData
              ? setFollowUps((x) => [
                  ...x.map((j) => (j.id === res.result.id ? res.result : j)),
                ])
              : setFollowUps((x) => [res.result, ...x]);
          }
          setAlert({
            isOpen: true,
            type: "success",
            title: "Success",
            subTitle: res.msg,
          });
          setShowForm(false);
        } else if (res)
          setAlert({
            isOpen: true,
            type: "error",
            title: "Error",
            subTitle: res.msg,
          });
      };
      if (values.id === 0) {
        API(controller.FollowUp + action.Post).post(
          ToFormData({
            ...values,
            inquiryId: inqData.id,
            followUpTime: new Date(values.followUpTime).toISOString(),
            createDate: new Date().toISOString(),
          }),
          onComplete
        );
      } else
        API(controller.FollowUp + action.Put).put(
          ToFormData({
            ...values,
            followUpTime: new Date(values.followUpTime).toISOString(),
            updateDate: new Date().toISOString(),
          }),
          onComplete
        );
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Paper className="p-[10px]">
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <div className="text-center mb-[20px] pt-[15px] w-full">
                <span className="text-[22px] mb-[5px] font-medium uppercase text-gray-500 m-0 p-0">
                  {updData ? "Update" : "Add"} Follow Up
                </span>
                <div className="relative flex justify-center">
                  <div className="border-bottom w-[60px]" />
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <InputDate
                label="Follow Up Date"
                name="followUpDate"
                value={values.followUpDate}
                error={errors.followUpDate}
                minDate={new Date()}
                required={true}
                onChange={(date) =>
                  handleInpDate("followUpDate", new Date(date).toISOString())
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <InputTime
                label="Follow Up Time"
                name="followUpTime"
                required={true}
                value={values.followUpTime}
                error={errors.followUpTime}
                onChange={(date) =>
                  handleInpDate("followUpTime", new Date(date))
                }
              />
            </Grid>
            <Grid item xs={12}>
              <Select
                label="Type"
                name="followUpTypeId"
                required={true}
                value={values.followUpTypeId}
                error={errors.followUpTypeId}
                onChange={handleInpChg}
                options={types}
              />
            </Grid>
            <Grid item xs={12}>
              <Input
                label="Note"
                name="note"
                value={values.note}
                error={errors.note}
                onChange={handleInpChg}
                multiline
                inputProps={{ maxLength: 500 }}
                rows={2}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Button
                variant="text"
                size="large"
                onClick={handleClose}
                fullWidth
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button loading={loading} size="large" type="submit" fullWidth>
                Submit
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Form>
    </>
  );
};

export default AddEditFollowUp;
